import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        layout: "auth",
      },
    },
    {
      path: "/recuperacion-contraseña",
      name: "forget-password",
      component: () => import("./views/Login.vue"),
      meta: {
        layout: "auth",
      },
    },
    {
      path: "/resumen",
      name: "resume",
      component: () => import("./views/Resume.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
    },
    {
      path: "/contextual",
      name: "satari",
      component: () => import("./views/Satari.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (
          localStorage.getItem("group") === "analista" ||
          localStorage.getItem("group") === "marketing"
        ) {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/presencia",
      name: "infra",
      component: () => import("./views/Infra.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (
          localStorage.getItem("group") === "analista" ||
          localStorage.getItem("group") === "marketing"
        ) {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/contenido",
      name: "content",
      component: () => import("./views/Content.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "analista") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/contenido/edit/:id",
      name: "content_detail",
      component: () => import("./views/ContentSingle.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "analista") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/ofertas/gestion/:id",
      name: "content_publish",
      component: () => import("./views/ContentManager.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "analista") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/ofertas/nueva",
      name: "new_content",
      component: () => import("./views/ContentSingle.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "analista") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/ofertas/gestion",
      name: "content_manager",
      component: () => import("./views/ContentManager.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "analista") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/clusters",
      name: "stores",
      component: () => import("./views/Stores.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (
          localStorage.getItem("group") === "analista" ||
          localStorage.getItem("group") === "marketing"
        ) {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/descargas",
      name: "downloads",
      component: () => import("./views/Downloads.vue"),
      meta: {
        layout: "default",
        isAuthenticated: true,
      },
      beforeEnter: function (to, from, next) {
        if (localStorage.getItem("group") === "marketing") {
          next("/resumen");
        } else {
          next();
        }
      },
    },
    {
      path: "/password-recovery",
      name: "password_recovery",
      component: () => import("./views/PasswordRecovery.vue"),
      meta: {
        layout: "auth",
      },
    },
    {
      path: "/error-500",
      name: "Error_500",
      meta: {
        layout: "error_500",
      },
    },
    {
      path: "*",
      name: "Error_400",
      meta: {
        layout: "error_400",
      },
    },
  ],
});

// Antes de entrar a alguna ruta verificamos
// si la ruta require autenticación y si nuestro usuario
// está autenticado en caso de no cumplir se devuelve al
// login.
router.beforeEach((to, from, next) => {
  //
  try {
    store.dispatch("auth/inspectToken");
  } catch (error) {
    console.log(error);
  }

  const isAuthenticated = to.matched.some((x) => x.meta.isAuthenticated);
  const currentUser = store.getters["auth/isLoggedIn"];

  if (isAuthenticated && currentUser.refresh == "") {
    next("/");
  } else if (!isAuthenticated && currentUser.refresh != "") {
    next("/resumen");
  } else if (!isAuthenticated && currentUser.refresh == "") {
    next();
  }
  next();
});

export default router;
